import React, { useState, useEffect, useRef } from 'react';
import LineIcon from "react-lineicons";
import './BsDeliveryIcon.css';

const BsDeliveryIcon = ({ toolTipText = "" }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const iconRef = useRef(null);

  const handleClick = () => {
    setShowTooltip(prev => !prev); 
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (iconRef.current && !iconRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <div ref={iconRef} onClick={handleClick} className="icon">
      <LineIcon
        name="delivery"
        style={{
          color: "var(--bs-light-grey)",
          fontSize: "18px"
        }}
      />
      {showTooltip && (
        <div className="deliveryIconTooltip">
          {toolTipText}
        </div>
      )}
    </div>
  );
};

export default React.memo(BsDeliveryIcon);
